import { PageLoading } from '@/components/page-loading'
import { Suspense, useState, useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { ContentLayout } from '../content-layout'
import { Modal, Button } from 'antd'
import { SignTitle, SvgIcon } from '@/components'
import WAFCreate from '@/pages/waf/create-task'
import WAFTaskList from '@/pages/waf/task-list'
import WAFTaskDetail from '@/pages/waf/task-detail'
import { t } from '@/i18n'

export const WafLayout = () => {
  const [isShow, setIsShow] = useState(false)

  const onShow = () => {
    setIsShow(true)
  }

  const onHide = () => {
    setIsShow(false)
  }

  const menuList = [
    {
      key: 'create',
      label: t('创建任务'),
      component: <WAFCreate />,
    },
    {
      key: 'task',
      label: t('任务列表'),
      component: <WAFTaskList />,
    },
    {
      key: 'task',
      label: t('任务详情'),
      component: <WAFTaskDetail />,
      show: false,
      name: 'detail',
    },
  ]

  const rightSlot = (
    <div
      onClick={() => {
        onShow()
      }}
      className="description"
    >
      <SvgIcon name={'场景描述'} width={14} style={{ marginRight: '6px', height: 14 }} />
      <span>{t('场景描述')}</span>
    </div>
  )

  return (
    <>
      <ContentLayout menuList={menuList} rightSlot={rightSlot}>
        <Suspense fallback={<PageLoading />}>
          <Outlet />
        </Suspense>
      </ContentLayout>
      <Modal
        title={<SignTitle show>{t('场景描述')}</SignTitle>}
        open={isShow}
        onCancel={onHide}
        footer={null}
        centered
        width={600}
        maskClosable
        destroyOnClose
        getContainer={() => document.body}
      >
        <div
          className="title"
          style={{
            fontWeight: '500',
            fontSize: '14px',
            color: '#333333',
            marginBottom: '16px',
            marginLeft: '8px',
          }}
        >
          {t('可验证设备类型')}
        </div>
        <div
          className="content"
          style={{
            fontSize: '14px',
            color: '#666666',
            marginBottom: '24px',
            marginLeft: '8px',
          }}
        >
          {t('Web 安全防护/检测类安全产品（如WAF、IPS等）')}
        </div>
        <div
          className="title"
          style={{
            fontWeight: '500',
            fontSize: '14px',
            color: '#333333',
            marginBottom: '16px',
            marginLeft: '8px',
          }}
        >
          {t('验证原理')}
        </div>
        <div
          className="content"
          style={{
            fontSize: '14px',
            color: '#666666',
            marginBottom: '24px',
            marginLeft: '8px',
          }}
        >
          {t(
            '针对Web应用程序构造带有攻击向量的HTTP/HTTPS请求，同时分析安全设备的处置响应（设备拦截特征比对、正常请求响应比对或设备告警日志分析），评估Web安全防护/检测设备的安全防护能力有效性。',
          )}
        </div>
        <div
          className="title"
          style={{
            fontWeight: '500',
            fontSize: '14px',
            color: '#333333',
            marginBottom: '16px',
            marginLeft: '8px',
          }}
        >
          {t('使用说明')}
        </div>
        <div
          className="content"
          style={{
            fontSize: '14px',
            color: '#666666',
            marginBottom: '24px',
            marginLeft: '8px',
          }}
        >
          <div className="item" style={{ display: 'flex', marginBottom: '8px' }}>
            <SvgIcon
              name={'纸飞机'}
              width={14}
              height={14}
              style={{ marginRight: '6px', minWidth: '14px' }}
            />

            <span>
              {t('为保证是授权的攻击验证，在针对 Web安全设备评估前，需先行配置站点资源。')}
            </span>
          </div>
          <div className="item" style={{ display: 'flex', marginBottom: '8px' }}>
            <SvgIcon
              name={'纸飞机'}
              width={14}
              style={{ minWidth: '14px', marginRight: '6px', height: '14px' }}
            />

            <span>{t('攻击请求包含无损的Payload，对安全设备无害，且包含bypass规则。')}</span>
          </div>
          <div className="item" style={{ display: 'flex', marginBottom: '8px' }}>
            <SvgIcon
              name={'纸飞机'}
              width={14}
              height={14}
              style={{ marginRight: '6px', minWidth: '14px' }}
            />

            <span>
              {t(
                '内置丰富攻防实战场景下积累的Web攻击特征，支持用户自定义Web攻击向量和组合各类攻击向量模板。',
              )}
            </span>
          </div>
          <div className="item" style={{ display: 'flex', marginBottom: '8px' }}>
            <SvgIcon name={'纸飞机'} width={14} style={{ marginRight: '6px', height: '14px' }} />
            <span>{t('支持动态编码，可验证Web安全防护/检测设备的解码能力。')}</span>
          </div>
        </div>
      </Modal>
    </>
  )
}
